import textile from "textile-js";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import textileViewStyles from "../../assets/styles/components/textile_view";

const useStyles = makeStyles(textileViewStyles);

const TextileView = (props) => {
  const classes = useStyles();
  const { text } = props;

  return (
    <Box className={classes.textWrapper}>
      <div
        dangerouslySetInnerHTML={{
          __html: textile(text ?? ""),
        }}
      />
    </Box>
  );
};

export default TextileView;
